import { Link } from 'react-router-dom'
import styles from './Home.module.css'

import portada from '../images/portada_socialinweb.webp'
import seccio3 from '../images/seccio3.webp' 
import seccio4 from '../images/seccio4.webp' 
import image1 from '../images/voice-feature.webp'
import image2 from '../images/planning-feature.webp'
import image3 from '../images/reports-feature.webp'
import image4 from '../images/presentacioSocialin.webp'
import SocialinPDF from '../documents/Socialin.pdf'

const Home = (props) => {

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <main className={styles.homeSection}>
      <section className={styles.heroImageContainer}>
        <img src={portada} alt="Socialin" className={styles.heroImage} />
        <h1 className={styles.title}>Socialin</h1>
        {/* <h2 className={styles.title2}>{props.language === 'ca' ? 'Fes les coses més fàcils a la teva organització' : props.language === 'es-ES' ? 'Haz las cosas más fáciles en tu organización' : 'Make things easier in your organization'}</h2> */}
        <h2 className={styles.title2}>Fes les coses més fàcils a la teva organització</h2>
      </section>
      <section className={styles.descriptionSection}>
        {/* <h2 className={styles.description}>{props.language === 'ca' ? 'Dedica el temps a allò veritablement important.' : props.language === 'es-ES' ? 'Dedica el tiempo a lo verdaderamente importante.' : "Spend time on what's really important."}</h2> */}
        <h2 className={styles.description}>Dedica el temps a allò veritablement important.</h2>
      </section>
      <section className={styles.descriptionSection}>
        {/* <h2 className={styles.description}>{props.language === 'ca' ? 'Socialin és la solució perfecta per ' : props.language === 'es-ES' ? 'Socialin es la solución perfecta para ' : 'Socialin is the perfect solution for ' }<strong>{props.language === 'ca' ? 'digitalitzar' : props.language === 'es-ES' ? 'digitalizar' : 'digitize'}</strong> la teva organització i optimitzar el <strong>seguiment</strong> d'usuaris. Amb funcions avançades com la <strong>transcripció automàtica</strong> de veu, Socialin et permet planificar i realitzar eficientment els seguiments de les <strong>persones ateses</strong> de la teva organització.</h2> */}
        <h2 className={styles.description}>Socialin és la solució perfecta per <strong>digitalitzar</strong> la teva organització i optimitzar el <strong>seguiment</strong> d'usuaris. Amb funcions avançades com la <strong>transcripció automàtica</strong> de veu, Socialin et permet planificar i realitzar eficientment els seguiments de les <strong>persones ateses</strong> de la teva organització.</h2>
      </section>
      <section className={styles.descriptionSection3}>
        <div className={styles.descriptionSection3_1}>
          <h2 className={styles.description}>Amb la transcripció automàtica de veu redueixes un 100% el temps de redacció dels seguiments.</h2>
          <p className={styles.texts}>Introdueix seguiments utilitzant només la teva veu i redueix el treball administratiu. Deixa que la tecnologia treballi per tu.</p>
          <p className={styles.texts}><span><Link to="/transcripcio" onClick={scrollToTop}>Més informació</Link></span><i className="fa-solid fa-angle-right"></i></p>
        </div>
        <div className={styles.descriptionSection3_2}>
          <img src={seccio3} alt="Transcripció automàtica de veu" className={styles.featureImage} />
        </div>
      </section>
      <section className={styles.descriptionSection3}>
        <div className={styles.imageSlider}>
            <img src={seccio4} alt="Transcripció automàtica de veu"  />
            <img src={seccio3} alt="Transcripció automàtica de veu"  />
        </div>
        <div className={styles.descriptionSection3_1}>
          <h2 className={styles.description}>Utilitza la plataforma que més s'adapti a les persones de la teva organització.</h2>
          <p className={styles.texts}>No et limitis a una app mòvil o a una aplicació web i utiliza també Telegram per conectar amb els professionals i usuaris, reduint els temps d'adopció de la tecnologia al utilizar eines ja conegudes.</p>
          <p className={styles.texts}><span><Link to="/digitalitza" onClick={scrollToTop}>Més informació</Link></span><i className="fa-solid fa-angle-right"></i></p>
        </div>
      </section>
      <section className={styles.featuresGallery}>
        <Link to="/transcripcio" className={styles.feature} onClick={scrollToTop}>
          <img src={image1} alt="Transcripció automàtica de veu" className={styles.featureImage} />
          <h3 className={styles.featureTitle}>Transcripció Automàtica</h3>
          <p className={styles.featureDescription}>Introdueix seguiments usant només la teva veu i redueix el treball manual.</p>
          <i className="fa-solid fa-arrow-right"></i>
        </Link>
        <Link to="" className={styles.feature} onClick={scrollToTop}>
          <img src={image2} alt="Planificació eficient" className={styles.featureImage} />
          <h3 className={styles.featureTitle}>Planificació Seguiments</h3>
          <p className={styles.featureDescription}>Organitza i assigna seguiments automàticament des de qualsevol dispositiu.</p>
          <i className="fa-solid fa-arrow-right"></i>
        </Link>
        <Link to="" className={styles.feature} onClick={scrollToTop}>
          <img src={image3} alt="Informes visuals" className={styles.featureImage} />
          <h3 className={styles.featureTitle}>Informes Visuals</h3>
          <p className={styles.featureDescription}>Genera informes clars i efectius amb un sol clic, facilitant la presa de decisions.</p>
          <i className="fa-solid fa-arrow-right"></i>
        </Link>
        <a href={SocialinPDF} className={styles.feature} download>
          <img src={image4} alt="Informes visuals" className={styles.featureImage} />
          <h3 className={styles.featureTitle}>Presentació Socialin</h3>
          <p className={styles.featureDescription}>Descarrega la presentació per analitzar-la més a fons.</p>
          <i className="fa-solid fa-arrow-right"></i>
        </a>
      </section>
    </main>
  )
}

export default Home